export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';
export const facebookBaseUrl = 'https://graph.facebook.com/v19.0';
